module.exports = __webpack_public_path__ + "img/section3.e0e66b79.svg";